import {
    sendPostRequest, sendPutRequest, sendDeleteRequest, sendGetRequest
} from "@/helper/requests";
import surveys from "@/urls/roles/admin";

const state = {
    fields: [],
    field: [],
}

const getters = {
    getFieldData: state => {
      /**
       * Возвращает список всех полей
       */
        return state.fields
    },
    getFieldDetail: state => {
      /**
       * Возвращает детальную информацию о конкретном поле
       */
        return state.field
    },
}

const mutations = {
    set_fields: (state, data) => {
      /**
       * Устанавливает список всех полей
       */
        state.fields = data
    },
    set_field: (state, data) => {
      /**
       * Устанавливает детальную информацию о поле
       */
        state.field = data
    }
}

const actions = {
    loadFields: ({commit}, {url, finalizer}) => {
      /**
       * Загружает список всех полей
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       */
        if (!url)
            url = surveys.ADMIN.FIELDS.LIST()
        sendGetRequest(
            url,
            (data) => {
                commit('set_fields', data);
                finalizer(data, url);
            }
        )
    },
    loadFieldDetail: ({commit, getters}, {id, finalizer}) => {
      /**
       * Загружает детальную информацию о конкретном поле
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {number} id - Идентификатор поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       */
        sendGetRequest(
            surveys.ADMIN.FIELDS.DETAIL(id),
            finalizer
        )
    },
    createField: ({dispatch, commit}, {data, finalizer, catcher}) => {
      /**
       * Создает новое поле
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для создания поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        sendPostRequest(
            surveys.ADMIN.FIELDS.SAVE(),
            data,
            finalizer,
            catcher
        )
    },
    updateField: ({dispatch, commit}, {data, finalizer, catcher}) => {
      /**
       * Обновляет существующее поле
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Обновленные данные поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        sendPutRequest(
            surveys.ADMIN.FIELDS.EDIT(data.id),
            data,
            finalizer,
            catcher
        )
    },
    deleteFieldDetail: ({dispatch, commit}, {data, finalizer, catcher}) => {
      /**
       * Удаляет поле
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для удаления поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        sendDeleteRequest(
            surveys.ADMIN.FIELDS.DELETE(data.id),
            finalizer,
            catcher
        )
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
